import {memo} from "react";
import {useDraggable} from "@dnd-kit/core";
import {
    FloorplanReservationItemDTO
} from "crqlar-react-common/dist/models/floorplan/floorplanReservationItem.dto";
import {DragData} from "../types";

interface Props {
    id: string;
    reservation: FloorplanReservationItemDTO;
    sourceTableId: string;
    disabled?: boolean;
    children: React.ReactNode;
}

const DraggableTableCard: React.FC<Props> = ({
                                                 id,
                                                 reservation,
                                                 sourceTableId,
                                                 disabled = false,
                                                 children
                                             }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        isDragging,
    } = useDraggable({
        id,
        disabled,
        data: {type: "assigned", reservation, sourceTableId} as DragData,
    });

    return (
        <div
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            style={{
                opacity: isDragging ? 0.5 : 1,
                pointerEvents: 'auto',
                cursor: disabled ? 'default' : 'grab',
            }}
        >
            {children}
        </div>
    );
};

export default memo(DraggableTableCard);
